import { useLocalizedLifeAreas } from 'features/life-areas';
import { useMemo } from 'react';

export const useTextFilteredLifeAreas = (searchText: string) => {
  const lifeAreas = useLocalizedLifeAreas();

  return useMemo(() => {
    if (!searchText) {
      return [];
    }
    const trimmedSearchText = searchText.trim().toLowerCase();

    return lifeAreas
      .filter(({ name }) => name.toLowerCase().includes(trimmedSearchText))
      .sort((a, b) => a.name.localeCompare(b.name));
  }, [searchText, lifeAreas]);
};
